var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDixa = function SvgDixa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.35573 0.861576C9.43117 -0.910796 13.3624 0.138635 15.1381 3.20822C15.7222 4.21975 16 5.32166 16 6.4119C16 8.62999 14.8461 10.7874 12.7841 11.9768L8.16098 14.6412L7.21732 15.1834L5.83906 15.9792C5.73713 16.0381 5.61008 15.9649 5.61008 15.8474V12.6907C5.61008 12.5041 5.56072 12.3205 5.46697 12.1584L1.07841 4.57306C0.916893 4.29438 1.01298 3.93757 1.29249 3.77666L6.35573 0.861576ZM9.03892 9.19554L10.6403 8.27175C11.3296 7.8753 11.7122 7.15527 11.7122 6.41484C11.7122 6.05337 11.6217 5.68316 11.426 5.34792C10.8331 4.32473 9.52492 3.97492 8.49948 4.56668L6.89546 5.48785C6.75556 5.5683 6.70766 5.74671 6.78827 5.88634L8.63967 9.08885C8.72057 9.22819 8.89903 9.276 9.03892 9.19554Z",
    fill: "currentColor"
  })));
};
export default SvgDixa;